import { render, staticRenderFns } from "./WjPub.vue?vue&type=template&id=2ccd30e0&scoped=true&"
import script from "./WjPub.vue?vue&type=script&lang=js&"
export * from "./WjPub.vue?vue&type=script&lang=js&"
import style0 from "./WjPub.vue?vue&type=style&index=0&id=2ccd30e0&scoped=true&lang=scss&"
import style1 from "./WjPub.vue?vue&type=style&index=1&id=2ccd30e0&scoped=true&lang=css&"
import style2 from "./WjPub.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd30e0",
  null
  
)

export default component.exports